import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withFetch,
    withInterceptorsFromDi,
    withXsrfConfiguration,
} from '@angular/common/http';
import { inject, isDevMode, NgModule, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ForwardedHostInterceptor } from '@core-app/interceptors/forwarded-host.interceptor';
import { LayoutModule } from '@core-app/layout/layout.module';
import { BootstrapService } from '@core-app/services/bootstrap.service';
import { X_SERVICE_ZONE } from '@core-app/tokens';
import { ICON_CONFIG } from '@gallaghercp/core-components/icon';
import { appReducer, CacheService, CoreModule, metaReducers } from '@gallaghercp/core-frontend';
import { APP_CONFIG_TOKEN, TRANSLATE_SERVICE } from '@gallaghercp/core-frontend-contracts';
import { StoreModule } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_CONFIG as LOCAL_APP_CONFIG } from './app.config';
import { ClientRoutingModule } from './client/client-routing.module';

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ClientRoutingModule,
        AppRoutingModule,
        CoreModule,
        LayoutModule,
        StoreModule.forRoot({ app: appReducer }, { metaReducers }),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode() && (LOCAL_APP_CONFIG as any).pwa?.enabled === true,
            registrationStrategy: 'registerImmediately',
        }),
    ],
    providers: [
        {
            provide: ICON_CONFIG,
            useValue: {
                baseUrl: ['/assets/img/icons/'],
            },
        },
        provideZoneChangeDetection(),
        provideHttpClient(
            withFetch(),
            withInterceptorsFromDi(),
            withXsrfConfiguration({
                cookieName: 'XSRF-TOKEN',
                headerName: 'X-XSRF-TOKEN',
            }),
        ),
        provideClientHydration(withNoHttpTransferCache()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ForwardedHostInterceptor,
            multi: true,
        },
        {
            provide: X_SERVICE_ZONE,
            useFactory: () => {
                const cacheService = inject(CacheService);
                const storedValue = cacheService.getFromStorage('x-service-zone');
                return storedValue ?? '1';
            },
        },
        {
            provide: APP_CONFIG_TOKEN,
            useValue: LOCAL_APP_CONFIG,
        },
        {
            provide: TRANSLATE_SERVICE,
            useExisting: TranslateService,
        },
        provideAppInitializer(() => {
            const bootstrapService = inject(BootstrapService);
            return bootstrapService.initialise();
        }),
    ],
})
export class AppModule {}
